import { useCallback, useState } from 'react'

import { upload } from '@/services/units/upload'

export const useUnitCollectUploadOptions = () => {
  const [isLoading, setIsLoading] = useState(false)

  const uploadOptions = useCallback(async (file: File, collectId: string) => {
    try {
      setIsLoading(true)
      const data = await upload(file, collectId)

      return data
    } catch (error) {
      console.error('Error upload units:', error)
      return null
    } finally {
      setIsLoading(false)
    }
  }, [])

  return { uploadOptions, isLoading }
}
